module.exports = __webpack_public_path__ + "media/V60.d69a3972.mp4";